import { cn } from '@/lib/utils';

interface ColorCardSkeletonProps {
  className?: string;
}

const ColorCardSkeleton = ({ className }: ColorCardSkeletonProps) => {
  return (
    <div className={cn('space-y-4', className)}>
      <div className="relative aspect-video rounded-lg overflow-hidden border bg-background/50 backdrop-blur-sm animate-pulse">
        <div className="w-full h-full bg-muted/50" />
        <div className="absolute bottom-4 right-4 w-8 h-8 rounded-lg bg-muted/50" />
      </div>
    </div>
  );
};

export default ColorCardSkeleton;